import React, { ReactNode } from "react";
import styles from "./AppBar.module.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MicNoneOutlinedIcon from "@mui/icons-material/MicNoneOutlined";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import SpatialAudioOffOutlinedIcon from "@mui/icons-material/SpatialAudioOffOutlined";
import PhoneInTalkOutlinedIcon from "@mui/icons-material/PhoneInTalkOutlined";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import { useNavigate } from "react-router-dom";

function AppBar({
  title,
  goBack,
  showLeftBack = true,
  showRightMore = true,
  onClickMore,
  onClickTitle,
  rightComponent,
  children,
}: {
  title?: string;
  goBack?: () => void;
  showLeftBack?: boolean;
  showRightMore?: boolean;
  onClickMore?: () => void;
  onClickTitle?: () => void;
  rightComponent?: ReactNode;
  children?: React.ReactNode;
}) {
  const navigate = useNavigate();
  const goBackFunc = () => {
    if (goBack) {
      goBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className={styles.header}>
      {children}
      {!children && (
        <>
          {showLeftBack && (
            <span className={styles.backButton} onClick={() => goBackFunc()}>
              {/* <ArrowBackIosIcon /> */}
              <i
                role="img"
                aria-label="返回"
                className="weui-icon-back-arrow-thin"
              ></i>
            </span>
          )}
          <span
            className={styles.title}
            onClick={() => onClickTitle?.()}
            style={{
              cursor: onClickTitle ? "pointer" : "default",
            }}
          >
            {title}
          </span>
          {!rightComponent && showRightMore && (
            <span className={styles.moreButton} onClick={() => onClickMore?.()}>
              <MoreHorizOutlinedIcon />
            </span>
          )}
          {rightComponent}
        </>
      )}
    </div>
  );
}

export default AppBar;
